import { render, staticRenderFns } from "./noticeDetails.vue?vue&type=template&id=423c8c0c&scoped=true"
import script from "./noticeDetails.vue?vue&type=script&lang=js"
export * from "./noticeDetails.vue?vue&type=script&lang=js"
import style0 from "./noticeDetails.vue?vue&type=style&index=0&id=423c8c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c8c0c",
  null
  
)

export default component.exports